import { fetchApi } from '@/config/axiosSetting';
import { PatchWagesParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchWages/patchWages.type';

export const patchWages = (params: PatchWagesParamsType) =>
  fetchApi.patch(
    `property/reports/${params?.id}/accident_users/damaged/adjusting/wages/`,
    params.data,
    {
      params: {
        damaged_id: params.damaged_id,
        id: params.id,
        source: params.source,
        wages_id: params.wages_id,
      },
    },
  );
